import { ref } from 'vue'
import { hapticError } from '@/telegramWebApp'

export interface Toast {
  id: number
  message: string
  kind: 'error' | 'info'
}

const toasts = ref<Toast[]>([])
let nextId = 1

function push(message: string, kind: Toast['kind']): void {
  const id = nextId++
  toasts.value.push({ id, message, kind })
  setTimeout(
    () => {
      toasts.value = toasts.value.filter((t) => t.id !== id)
    },
    kind === 'error' ? 6000 : 2500,
  )
}

export function useToast() {
  return {
    toasts,
    info: (message: string) => push(message, 'info'),
    error: (e: unknown, prefix = 'Something went wrong') => {
      hapticError()
      push(`${prefix}: ${e instanceof Error ? e.message : String(e)}`, 'error')
    },
  }
}
